const faqItems = [
  {
    q: '豆花视频收费吗？',
    a: '豆花视频完全免费，所有影视资源均可在线观看无需付费。我们致力于为用户提供免费的西瓜视频、芒果视频、丝瓜视频等高清影视内容，不收取任何会员费用。',
  },
  {
    q: '观看需要下载App或注册吗？',
    a: '无需下载任何软件，也无需注册登录。打开豆花视频即可免费在线观看，支持手机、平板和电脑多端访问，高清流畅不缓冲。',
  },
  {
    q: '视频画质怎么样？会卡顿吗？',
    a: '平台资源均支持1080P及以上高清画质，采用多线路智能调度技术确保播放流畅不缓冲。如遇播放卡顿，建议切换网络或刷新页面重试。',
  },
  {
    q: '影片多久更新一次？',
    a: '豆花视频每日同步更新最新影视资源，热门电视剧、电影、综艺和动漫番剧随播随更。你可以关注首页"最新动态"模块了解每日上架内容。',
  },
  {
    q: '如果找不到想看的影片怎么办？',
    a: '欢迎通过"联系我们"入口投稿或反馈。我们的内容团队会关注用户需求，持续扩充片库覆盖更多影视资源，努力让每位观众都能找到喜欢的影片。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">关于豆花视频，你想了解的都在这</p>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item) => (
            <details key={item.q} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed font-body">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}